import { CSSResultGroup, html, LitElement } from 'lit'
import { customElement, property } from 'lit/decorators.js'
import { hostStyle } from '@cloudsuite/mosaic-shared/styles/host.style.js'
import { inject } from '@cloudsuite/mosaic-shared/scripts/dependency-injection.js'
import { REAL, FAKE, registerDependency } from '@cloudsuite/mosaic-shared/scripts/dependency-injection.js'


export enum AllowDismiss {
  hiddenOnce = 'hiddenOnce',
  hiddenAlways = 'hiddenAlways',
}

const DISMISS_COOKIE_NAME = 'cs_{{ID}}_dismissed'
export const DISMISS_MANAGER = Symbol('DISMISS_MANAGER')

const CookieMaxAge = 31536000 * 1000

@registerDependency(REAL, DISMISS_MANAGER)
@registerDependency(FAKE, DISMISS_MANAGER)
export class DismissManager {

  static getCookieName(notificationId: string) {
    return DISMISS_COOKIE_NAME.replace('{{ID}}', notificationId)
  }

  dismiss(notificationId: string) {
    document.cookie = `${DismissManager.getCookieName(notificationId)}=1;path=/`
  }

  dismissPermanently(notificationId: string) {
    const expires = new Date(Date.now() + CookieMaxAge).toUTCString()
    document.cookie = `${DismissManager.getCookieName(notificationId)}=1;path=/;expires=${expires}`
  }
}

@customElement('csc-notification-banner')
export class CSCNotificationBanner extends LitElement {
  static override styles: CSSResultGroup = [hostStyle]

  @property({ type: String, attribute: 'notification-id' })
  notificationId = ''

  @property({ type: String })
  icon = ''

  @property({ type: String })
  variant = 'primary'

  @property({ type: String })
  dismiss = ''

  @inject(DISMISS_MANAGER)
  manager!: DismissManager

  private get dismissible() {
    return [AllowDismiss.hiddenOnce, AllowDismiss.hiddenAlways].includes(this.dismiss as AllowDismiss)
  }

  override render() {
    return html`
      <cse-banner
        class="csc-notification-banner"
        variant=${this.variant}
        ?dismissable=${this.dismissible}
        @cse-banner-dismissed="${this.dismissNotification}"
      >
        ${this.icon ? html`<cse-icon slot="icon" icon-name="${this.icon}" icon-style="light"></cse-icon>` : ''}
        <slot></slot>
      </cse-banner>
    `
  }

  dismissNotification() {
    if (this.dismiss === AllowDismiss.hiddenAlways) {
      this.manager.dismissPermanently(this.notificationId)
    }
    else {
      this.manager.dismiss(this.notificationId)
    }
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'csc-notificaton-banner': CSCNotificationBanner
  }
}
